import React from "react"
import echarts from "echarts"

import DataShop from "../../../data/shop"
import Util from "../../../util/util"
import "./ShopAnalysis.less"
import Loading from "../../../components/Loading"

class ShopAnalysis extends React.Component {
  constructor(props) {
    super(props)
    this.state = { list: [] }
  }
  componentDidMount() {
    this.getData()
  }

  componentWillUnmount() {
    Util.destroyCharts(this.chart)
  }

  getData() {
    let { floor, date } = this.props
    DataShop.getShopRank(floor, date).then(res => {
      this.setState({ list: res.data || [] }, () => {
        this.renderChart(res.data)
      })
    })
  }

  renderChart(shopData) {
    let { id } = this.props
    var len = shopData.length
    var legendData = []
    shopData.sort((a, b) => {
      return a.vnum - b.vnum
    })
    for (var i = 0; i < len; i++) {
      legendData.push(shopData[i].shop_name)
    }
    if (!legendData.length) {
      legendData = ["无数据"]
    }
    var seriesData = shopData.map(data => {
      var dataFormat = {
        value: 0,
        itemStyle: {
          //图形样式
          normal: {
            color: "#8560F8",
            opacity: 1,
            barBorderRadius: [0, 5, 5, 0], //（顺时针左上，右上，右下，左下）
          },
        },
      }
      dataFormat.value = data.vnum
      if (data.shop_id === id) {
        dataFormat.itemStyle.normal.color = "#FF32D9"
        dataFormat.itemStyle.normal.opacity = 1
      }
      return dataFormat
    })
    if (!seriesData.length) {
      seriesData = [{ name: "无数据", value: 0 }]
    }
    var option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
        },
      },
      grid: {
        top: 20,
        left: 10,
        right: 50,
        bottom: 10,
        containLabel: true,
      },
      yAxis: [
        {
          type: "category",
          data: legendData,
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            fontWeight: 500,
            color: "#fff",
          },
          fontFamily: "monospace",
        },
      ],
      xAxis: [
        {
          type: "value",
          show: false,
        },
      ],
      series: [
        {
          name: "来访数",
          type: "bar",
          barWidth: 8,
          label: {
            normal: {
              show: true,
              position: "right",
            },
          },
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          data: seriesData,
          silent: true,
        },
      ],
    }
    var chart = (this.chart = echarts.init(
      document.getElementById("chartRank")
    ))
    chart.setOption(option)
    Util.registerChartsResize(chart)
  }

  render() {
    let { list } = this.state
    let height = list.length * 25
    return (
      <div className="box-shop-analysis">
        <h2 className="shop-body-title">
          <i className="icon" />
          <span className="i-title">店铺排行</span>
        </h2>
        <div className="chart-container" id="chartRank" style={{ height }}>
          <Loading loading={true} />
        </div>
      </div>
    )
  }
}

export default ShopAnalysis
